import type { Collection, JSCodeshift } from 'jscodeshift';

/**
 * Adds a named import if it doesn't already exist.
 */
function addImport(
  root: Collection,
  sourceValue: string,
  importName: string,
  j: JSCodeshift,
): void {
  const existingImports = root.find(j.ImportDeclaration, {
    source: { value: sourceValue },
  });

  if (existingImports.size() > 0) {
    const namedImport = existingImports.find(j.ImportSpecifier, {
      imported: { name: importName },
    });

    if (namedImport.size() > 0) {
      return;
    }

    existingImports.forEach((path) => {
      if (path.node.specifiers) {
        path.node.specifiers.push(j.importSpecifier(j.identifier(importName)));
      }
    });
  } else {
    const newImport = j.importDeclaration(
      [j.importSpecifier(j.identifier(importName))],
      j.literal(sourceValue),
    );

    const firstImport = root.find(j.ImportDeclaration).at(0);
    if (firstImport.size() > 0) {
      firstImport.insertBefore(newImport);
    } else {
      // Insert at the beginning of the program
      const program = root.find(j.Program);
      if (program.size() > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        program.get('body', 0).insertBefore(newImport);
      }
    }
  }
}

export default addImport;
